import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import Typography from '@mui/material/Typography';
import type { TypographyProps } from '@mui/material/Typography';
import Link from '@mui/material/Link';
import Box from '@mui/material/Box';

export default function Footer(props: TypographyProps) {
  const appConfig = useSelector(
    (state: { appConfig: { wholesaleEmail?: string; wholesalePhone: string } }) => state.appConfig,
  );
  const { t } = useTranslation('common');

  return (
    <Box sx={{ textAlign: 'center', mt: 10, pb: 5 }}>
      <Typography
        variant="body2"
        {...props}
        sx={[{
          color: "text.secondary"
        }, ...(Array.isArray(props.sx) ? props.sx : [props.sx])]}>
        {t('footer.contactUs')}
        {' '}
        <Link color="inherit" target="_blank" href={`mailto:${appConfig.wholesaleEmail}`}>
          {appConfig.wholesaleEmail}
        </Link>
        {', '}
        <Link color="inherit" target="_blank" href={`tel:${appConfig.wholesalePhone}`}>
          {appConfig.wholesalePhone.replace(/^(\d{3})(\d{3})(\d{4})$/, '$1-$2-$3')}
        </Link>
        {', '}
        <Link
          href="https://smallwm.com"
          sx={{
            color: "#1769aa",
            fontStyle: 'italic'
          }}>
          {t('footer.poweredBy', { year: new Date().getFullYear() })}
        </Link>
      </Typography>
    </Box>
  );
}
